import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/certificate-operation-prints', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/certificate-operation-prints', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const studentCertificate = (options = {}) => {
    return httpClient
        .get('/api/certificate-operation-prints/student-certificates', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const printPdf = id => {
    return httpClient
        .get(`/api/certificate-operation-prints/print-pdf/`, id)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default {
    get,
    store,
    studentCertificate,
    printPdf
}
